import React from "react";
import { useController, Control, RegisterOptions, FieldValues, Path, useFormContext, PathValue } from "react-hook-form";
import { Dropdown } from "..";
import countries from "./countries.json";
import { DEFAULT_COUNTRY_CODE, DEFAULT_COUNTRY_LABEL } from "./types";

interface CountryDropdownProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  onDismiss?(): void;
  rules?: RegisterOptions;
  clearFields: Array<Path<T>>;
}

const dropdownCountries = countries.map(({ label }) => ({ label, value: label }));

export const countryLabelToCode = (countryLabel: string) => {
  const found = countries.find((c) => c.label === countryLabel);
  return found ? found.code : DEFAULT_COUNTRY_CODE;
};

export const countryCodeToLabel = (code?: string) => {
  const found = countries.find((c) => c.code === code);
  return found ? found.label : DEFAULT_COUNTRY_LABEL;
};
export const isUnitedStates = (countryLabel: string) => countryLabel === DEFAULT_COUNTRY_LABEL;

export default function CountryDropdown<T extends FieldValues>({
  control,
  name,
  rules,
  onDismiss,
  clearFields,
}: CountryDropdownProps<T>) {
  const { setValue } = useFormContext<T>();
  const {
    field: { onChange: onChangeController, value },
    fieldState: { error },
  } = useController({ control, name, rules });

  const onChange = (v: any) => {
    // when country value changes, clear out the other related address fields
    clearFields.forEach((field) => {
      setValue(field, "" as PathValue<T, Path<T>>, { shouldValidate: false });
    });
    onChangeController(v);
  };

  return (
    <Dropdown
      list={dropdownCountries}
      setValue={onChange}
      {...{ error, value, onDismiss }}
      label="Country/Region"
      testID="CountriesDropdown"
      searchable
      dropDownContainerMaxHeight={400}
    />
  );
}
